import { render } from "./SolutionDetails.vue?vue&type=template&id=5d32761f&scoped=true"
import script from "./SolutionDetails.vue?vue&type=script&lang=js"
export * from "./SolutionDetails.vue?vue&type=script&lang=js"

import "./SolutionDetails.vue?vue&type=style&index=0&id=5d32761f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d32761f"]])

export default __exports__